
export default function FormStructure({ children }: { children: React.ReactNode }) {
    return <div className={`flex flex-col items-center md:justify-center md:h-screen md:min-h-[70vh] bg-no-repeat bg-cover bg-bottom bg-none md:bg-[url('https://giunti-al-punto-cms.s3.eu-south-1.amazonaws.com/giraglia-straight.webp')]`}>
        <h1 className="text-6xl text-center mb-8 font-bold text-blue-950 hidden md:flex">Giraglia Database</h1>
        <div
            className="flex flex-col items-center justify-center mt-10 rounded-lg w-[300px]">
            {children}
        </div>
    </div>
}